import React from "react";
// import * as Async from "../app/asyncComponents";
import PrivateLayoutQuestionaire from "../layout/privateLayoutQuestionaire";
import PublicLayout from "../layout/publicLayout";
import ProtectedLayoutStore from "../layout/protectedLayout/protectedLayoutStore/protectedLayoutStore";
import Questionaire from "../containers/questionaire";
import Login from "../containers/authentication/login";
import Signup from "../containers/authentication/signup";
import ForgotPassword from "../containers/forgotPassword";
import Payment from "../containers/payment";
import PaymentSuccess from "../containers/paymentSuccess";
import Waiting from "../containers/waiting";
import Dashboard from "../containers/dashboard";
import PageNotFound from "../containers/pageNotFound";
import EditProfile from "../containers/profile/editProfile";
import SkincareSteps from "../containers/skincareSteps";
import HolisticSkincare from "../containers/holisticSkincare";
import GoodStuff from "../containers/goodStuff";
import Entry from "../containers/entry";
import AppreciateYou from "../containers/appreciateYou";
import LikedYourSpace from "../containers/likedYourSpace";
import SkincareGuide from "../containers/skincareGuide";
import Benefits from "../containers/benefits";
import ProductOpinion from "../containers/product-opinion";
import MissingSkincare from "../containers/missingSkincare";
import EarnCashBack from "../containers/earnCashBack";
import PaymentBasicInfo from "../containers/payment-basic-info";
import PreviewQuiz from "../containers/PreviewQuiz/PreviewQuiz";
import HomeStore from "../containers/homeStore";
import PaymentHistory from "../containers/payment-history";
import ThankyouContainer from "../containers/thankyou";
import SkincareTrackerContainer from "../containers/skincare-tracker/SkincareTrackerContainer";
import HowToUseContainer from "../containers/how-to-use/HowToUseContainer";
import WhereToBuyContainer from "../containers/where-to-buy/WhereToBuyContainer";
import SkinSolutionContainer from "../containers/skin-solution/SkinSolutionContainer";
import PersonalJournalContainer from "../containers/personal-journal/PersonalJournalContainer";
import IngredientCheckerContainer from "../containers/ingredient-checker/IngredientCheckerContainer";
import ReviseRoutineContainer from "../containers/revise-routine/ReviseRoutineContainer";
import BillingSuscription from "../containers/subscription";
import SubscriptionPage from "../containers/subscription";

interface RouteConfigProps {
  name: string;
  path: string;
  layout: React.FC | undefined;
  element: React.FC | any;
}

export const routes: Array<RouteConfigProps> = [
  {
    name: "entry",
    path: "/",
    layout: PublicLayout,
    element: Entry,
  },
  {
    name: "questionaire",
    path: "/skincaresteps",
    layout: PrivateLayoutQuestionaire,
    element: Questionaire,
  },
  {
    name: "User Register",
    path: "/payment-info",
    layout: PublicLayout,
    element: PaymentHistory,
    // element: PaymentBasicInfo,
  },
  {
    name: "Home Store",
    path: "/quiz-response/:id",
    layout: PublicLayout,
    element: HomeStore,
  },
  // {
  //   name: "Payment History",
  //   path: "/payment-history",
  //   layout: PublicLayout,
  //   element: PaymentHistory,
  // },
  {
    name: "Product Opinion",
    path: "/product-opinion",
    layout: PrivateLayoutQuestionaire,
    element: ProductOpinion,
  },
  {
    name: "Thank You",
    path: "/thank-you",
    layout: PublicLayout,
    element: ThankyouContainer,
  },
  {
    name: "Know Your Skincare Guide",
    path: "/skincare-guide",
    layout: PrivateLayoutQuestionaire,
    element: SkincareGuide,
  },
  {
    name: "Benefits",
    path: "/benefits",
    layout: PrivateLayoutQuestionaire,
    element: Benefits,
  },
  {
    name: "login",
    path: "/login",
    layout: PublicLayout,
    element: Login,
  },
  {
    name: "signup",
    path: "/signup",
    layout: PublicLayout,
    element: Signup,
  },
  {
    name: "Forgot Password",
    path: "/forgot-password",
    layout: PublicLayout,
    element: ForgotPassword,
  },
  // {
  //   name: "Your Skin Space",
  //   path: "/store",
  //   layout: ProtectedLayoutStore,
  //   element: Dashboard,
  // },
  {
    name: "Preview Quiz Result",
    path: "/preview-quiz",
    layout: PrivateLayoutQuestionaire,
    element: PreviewQuiz,
  },
  // {
  //   name: "Edit Profile",
  //   path: "/editProfile",
  //   layout: Async.ProtectedLayoutStore,
  //   element: Async.EditProfile,
  // },
  // {
  //   name: "Payment",
  //   path: "/payment",
  //   layout: PrivateLayoutQuestionaire,
  //   element: Payment,
  // },
  // {
  //   name: "payment",
  //   path: "/payment-success",
  //   layout: PrivateLayoutQuestionaire,
  //   element: PaymentSuccess,
  // },
  {
    name: "Processing",
    path: "/processing",
    layout: PrivateLayoutQuestionaire,
    element: Waiting,
  },
  {
    name: "Your Skin Space",
    path: "/store",
    layout: ProtectedLayoutStore,
    element: Dashboard,
  },
  {
    name: "NotFound",
    path: "*",
    layout: PublicLayout,
    element: PageNotFound,
  },

  {
    name: "Edit Profile",
    path: "/edit-profile",
    // layout: PrivateLayoutQuestionaire,
    layout: ProtectedLayoutStore,
    element: EditProfile,
  },
  {
    name: "Billing and Suscription",
    path: "/billing-subscription",
    // layout: PrivateLayoutQuestionaire,
    layout: ProtectedLayoutStore,
    element: BillingSuscription,
  },
  {
    name: "Skincare Steps",
    path: "/store/skincare-steps",
    layout: ProtectedLayoutStore,
    element: SkincareSteps,
  },
  {
    name: "How to Use",
    path: "/store/how-to-use",
    layout: ProtectedLayoutStore,
    element: HowToUseContainer,
  },
  {
    name: "Where to Buy",
    path: "/store/where-to-buy",
    layout: ProtectedLayoutStore,
    // element: WhereToBuyContainer,
    element: MissingSkincare,
  },
  {
    name: "Ingredient Checker",
    path: "/store/ingredient-checker",
    layout: ProtectedLayoutStore,
    element: IngredientCheckerContainer,
  },
  {
    name: "Skincare Steps",
    path: "/store/skincare-tracker",
    layout: ProtectedLayoutStore,
    element: SkincareTrackerContainer,
  },
  {
    name: "Revise Routine",
    path: "/store/revise-routine",
    layout: ProtectedLayoutStore,
    element: ReviseRoutineContainer,
  },
  {
    name: "Missing Skincare",
    path: "/store/missing-skincare",
    layout: ProtectedLayoutStore,
    element: MissingSkincare,
  },
  {
    name: "Progress Journal",
    path: "/store/personal-journal",
    layout: ProtectedLayoutStore,
    element: PersonalJournalContainer,
  },
  // {
  //   name: "Holistic Skincare",
  //   path: "/store/holistic-care",
  //   layout: ProtectedLayoutStore,
  //   element: HolisticSkincare,
  // },
  {
    name: "Skin Solution",
    path: "/store/skin-solution",
    layout: ProtectedLayoutStore,
    element: SkinSolutionContainer,
  },
  {
    name: "Cash Collect",
    path: "/store/the-good-stuff",
    layout: ProtectedLayoutStore,
    element: GoodStuff,
  },
  {
    name: "Appreciate You",
    path: "/store/appreciate-you",
    layout: ProtectedLayoutStore,
    element: AppreciateYou,
  },
  {
    name: "Liked Your Space",
    path: "/store/liked-your-space",
    layout: ProtectedLayoutStore,
    element: LikedYourSpace,
  },
  {
    name: "Earn Cash Back",
    path: "/store/earn-cash-back",
    layout: ProtectedLayoutStore,
    element: EarnCashBack,
  },
  {
    name: "Subscription",
    path: "/store/subscription",
    layout: ProtectedLayoutStore,
    element: SubscriptionPage,
  },
];
